var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 3.2C10.24 4.992 8.832 6.4 7.04 6.4C5.248 6.4 3.84 4.992 3.84 3.2C3.84 1.408 5.248 3.8147e-06 7.04 3.8147e-06C8.832 3.8147e-06 10.24 1.408 10.24 3.2ZM10.24 7.04L9.92 8.064C9.728 8.576 9.28 8.96 8.704 8.96H5.376C4.8 8.96 4.352 8.576 4.16 8.064L3.84 7.04C2.688 7.04 1.728 7.808 1.536 8.896L0 16H14.08L12.544 8.96C12.352 7.808 11.328 7.04 10.24 7.04Z",
    fill: "#7363F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoNumber);
export default __webpack_public_path__ + "static/media/PoNumber.5863fd4b64b4859d0190fe3a97d35459.svg";
export { ForwardRef as ReactComponent };